<template>
    <v-container fluid>
        <v-row>
            <v-col cols="4" style="float: left">
                <v-card>
                    <v-card-title class="justify-center">
                        <h1 v-if="!newToday.isFetching" style="font-size: 2.5em; padding-top: 15px;">
                            {{ newToday.data.length }}
                        </h1>
                        <v-progress-circular v-if="newToday.isFetching" indeterminate size="45" width="2"
                            color="primary">
                        </v-progress-circular>
                    </v-card-title>
                    <v-card-text>
                        {{ $t('servicesystem.common_objects.job_statistics.new_today') }}
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="4" style="float: left">
                <v-card>
                    <v-card-title class="justify-center">
                        <h1 v-if="!plannedToday.isFetching" style="font-size: 2.5em; padding-top: 15px;">
                            {{ plannedToday.data.length }}
                        </h1>
                        <v-progress-circular v-if="plannedToday.isFetching" indeterminate size="45" width="2"
                            color="primary">
                        </v-progress-circular>
                    </v-card-title>
                    <v-card-text>
                        {{ $t('servicesystem.common_objects.job_statistics.planned_today') }}
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col cols="4" style="float: left">
                <v-card>
                    <v-card-title class="justify-center">
                        <h1 v-if="!completedToday.isFetching" style="font-size: 2.5em; padding-top: 15px;">
                            {{ completedToday.data.length }}
                        </h1>
                        <v-progress-circular v-if="completedToday.isFetching" indeterminate size="45" width="2"
                            color="primary">
                        </v-progress-circular>
                    </v-card-title>
                    <v-card-text>
                        {{ $t('servicesystem.common_objects.job_statistics.completed_today') }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import client from "@/api/client";

export default {
        name: "JobsToday",
        props: [],
        components: {},

        data() {
            return {
                newToday: {
                    data: [], isFetching: false
                },
                plannedToday: {
                    data: [], isFetching: false
                },
                completedToday: {
                    data: [], isFetching: false
                }
            };
        },

        mounted() {
            this.newToday.isFetching = true;
            this.plannedToday.isFetching = true;
            this.completedToday.isFetching = true;
            client()
                .get("/api2/serviceprovider/statistics/new-today")
                .then((response) => {
                    this.newToday.isFetching = false;                                       
                    if (!response.data) return;
                    this.newToday.data = response.data;

                });
            client()
                .get("/api2/serviceprovider/statistics/planned-today")
                .then((response) => {
                    this.plannedToday.isFetching = false
                    if (!response.data) return;
                    this.plannedToday.data = response.data;

                });
            client()
                .get("/api2/serviceprovider/statistics/completed-today")
                .then((response) => {
                    this.completedToday.isFetching = false;
                    if (!response.data) return;
                    this.completedToday.data = response.data;

                });
        },

        methods: {},

        computed: {},

        watch: {},
    };
</script>


<style lang='scss' scoped></style>

